import { render, staticRenderFns } from "./AIVTimeSelect.vue?vue&type=template&id=896c0344&scoped=true"
import script from "./AIVTimeSelect.vue?vue&type=script&lang=js"
export * from "./AIVTimeSelect.vue?vue&type=script&lang=js"
import style0 from "./AIVTimeSelect.vue?vue&type=style&index=0&id=896c0344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896c0344",
  null
  
)

export default component.exports